.CalendarButtonWrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 16px;
}

.CalendarButton {
  width: 100%;
  justify-content: flex-start;
  text-align: left;
  align-items: flex-start;
  padding-left: 0;
  height: initial !important;

  &.isDisabled {
    &:hover {
      background-color: transparent;
    }
  }

  svg {
    margin-top: 2px;
  }
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bottomActions {
  display: flex;
  gap: 5px;
  align-items: center;

  > * {
    width: 50%;
  }
}
